export const currencyFormat = (number: number, currency = 'GBP', locale = 'en-GB') =>
  new Intl.NumberFormat(locale, { style: 'currency', currency }).format(number)

export const partialPrice = (formatted: string, decimals = 2) => formatted.replace('.' + '0'.repeat(decimals), '')

export const currencyFormatPartial = (number: number, decimals = 2, currency = 'GBP') =>
  partialPrice(currencyFormat(number, currency), decimals)
